import { render, staticRenderFns } from "./ProductScreeningBatchPopupIframe.vue?vue&type=template&id=2c72f085&"
import script from "./ProductScreeningBatchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductScreeningBatchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports